export const paragraphSize = (size) => {
  switch(size) {
    case 'xs':
      return 12
    case 'sm':
      return 14
    case 'md':
      return 16;
    case 'lg':
      return 20;
    case 'xl':
      return 24;
    case 'xxl':
      return 28;
    default:
      return 20
  }
}

//TODO: Tem que add a url das lives
export const schedule = [
  {
    week: 1,
    title: "Semana 1 | 03 de novembro a 9 de novembro",
    subjects: [
      "Linguagens, Códigos e suas tecnologias","Ciências Humanas","Redação"
    ],
    startDate: "2025-11-03T00:00:00-03:00",
    endDate: "2025-11-09T23:59:59-03:00",
    days: [
      {
        date: "2025-11-03T00:00:00-03:00",
        title: "SEGUNDA - 03/11",
        ebookLink: "ebook-03-11",
        simulatedLink: "simulado-sos-2025-03-11",
        liveUrl: "_c4vfcnLZ2o",
        asset: "thumb-seg-1",
        classes: [
          {
            class: "História (Prof. Alfredo)",
            hour: "2025-11-03T19:30:00-03:00",
            url: "",
          },
          {
            class: "Redação (Profa. Jana Rabelo)",
            hour: "2025-11-03T20:00:00-03:00",
            url: "",
          },
          {
            class: "INTERVALO",
            hour: "2025-11-03T20:30:00-03:00",
            url: "",
          },
          {
            class: "Redação (Profa. Jana Rabelo)",
            hour: "2025-11-03T20:40:00-03:00",
            url: "",
          },
          {
            class: "História (Prof. Alfredo)",
            hour: "2025-11-03T21:10:00-03:00",
            url: "",
          },
        ],
      },
      {
        date: "2025-11-04T00:00:00-03:00",
        title: "TERÇA - 04/11",
        ebookLink: "ebook-04-11",
        simulatedLink: "simulado-sos-2025-04-11",
        liveUrl: "_xT9QVg5JtQ",
        asset: "thumb-ter-1",
        classes: [
          {
            hour: "2025-11-04T19:30:00-03:00",
            class: 'História (Prof. Alan)',
            url: ""
          },
          {
            hour: "2025-11-04T20:00:00-03:00",
            class: 'Português (Prof. Ricardinho)',
            url: ""
          },
          {
            hour: "2025-11-04T20:30:00-03:00",
            class: 'INTERVALO',
            url: ""
          },
          {
            hour: "2025-11-04T20:40:00-03:00",
            class: 'História (Prof. Alan)',
            url: ""
          },
          {
            hour: "2025-11-04T21:10:00-03:00",
            class: 'Português (Prof. Ricardinho)',
            url: ""
          }
        ],
      },
      {
        date: "2025-11-05T00:00:00-03:00",
        title: "QUARTA - 05/11",
        ebookLink: "ebook-05-11",
        simulatedLink: "simulado-sos-2025-05-11",
        liveUrl: "Dz_h9Xc97OQ",
        asset: "thumb-qua-1",
        classes: [
          {
            hour: "2025-11-05T19:30:00-03:00",
            class: 'Geografia (Prof. Dudu)',
            url: ""
          },
          {
            hour: "2025-11-05T20:00:00-03:00",
            class: 'Redação (Profa. Dani)',
            url: ""
          },
          {
            hour: "2025-11-05T20:30:00-03:00",
            class: 'INTERVALO',
            url: ""
          },
          {
            hour: "2025-11-05T20:40:00-03:00",
            class: 'Redação (Profa. Dani)',
            url: ""
          },
          {
            hour: "2025-11-05T21:10:00-03:00",
            class: 'Geografia (Prof. Dudu)',
            url: ""
          }
        ],
      },
      {
        date: "2025-11-06T00:00:00-03:00",
        title: "QUINTA - 06/11",
        ebookLink: "ebook-06-11",
        simulatedLink: "simulado-sos-2025-06-11",
        liveUrl: "v5x9bwP0nco",
        asset: "thumb-qui-1",
        classes: [
          {
            hour: "2025-11-06T19:30:00-03:00",
            class: 'Sociologia (Prof. Bruno Nichel)',
            url: ''
          },
          {
            hour: "2025-11-06T20:00:00-03:00",
            class: 'Geografia/Atualidades (Prof. Víctor)',
            url: ''
          },
          {
            hour: "2025-11-06T20:30:00-03:00",
            class: 'INTERVALO',
            url: ''
          },
          {
            hour: "2025-11-06T20:40:00-03:00",
            class: 'Sociologia (Prof. Bruno Nichel)',
            url: ''
          },
          {
            hour: "2025-11-06T21:10:00-03:00",
            class: 'Geografia/Atualidades (Prof. Víctor)',
            url: ''
          }
        ],
      },
      {
        date: "2025-11-07T00:00:00-03:00",
        title: "SEXTA - 07/11",
        ebookLink: "ebook-07-11",
        simulatedLink: "simulado-sos-2025-07-11",
        liveUrl: "L1frMx6QomA",
        asset: "thumb-sex-1",
        classes: [
          {
            hour: "2025-11-07T19:30:00-03:00",
            class: 'Literatura (Prof. Guilherme Suman)',
            url: ''
          },
          {
            hour: "2025-11-07T20:00:00-03:00",
            class: 'Filosofia (Prof. Thiago Suman)',
            url: ''
          },
          {
            hour: "2025-11-07T20:30:00-03:00",
            class: 'INTERVALO',
            url: ''
          },
          {
            hour: "2025-11-07T20:40:00-03:00",
            class: 'Literatura (Prof. Guilherme Suman)',
            url: ''
          },
          {
            hour: "2025-11-07T21:10:00-03:00",
            class: 'Filosofia (Prof. Thiago Suman)',
            url: ''
          },
        ],
      },
      {
        date: "2025-11-08T00:00:00-03:00",
        title: "SÁBADO - 08/11",
        liveUrl: "aEiaC-y9v8E",
        simulatedLink: "simulado-sos-2025-08-11-sabado",
        ebookLink: "ebook-08-11",
        asset: "thumb-sab-1",
        classes: [
          {
            class: "14h00 às 20h15 - Aulão",
            hour: "2025-11-08T14:00:00-03:00",
            end: "2025-11-08T20:15:00-03:00",
            url: "",
          }
        ],
      },
      {
        date: "2025-11-09T00:00:00-03:00",
        title: "DOMINGO - 09/11",
        liveUrl: "GItjMcUC96E",
        asset: "thumb-dom",
        classes: [
          {
            class: "Cobertura e correção da prova do Enem",
            hour: "2025-11-09T19:00:00-03:00",
            url: "",
          }
        ],
      },
    ],
  },
  {
    week: 2,
    title: "Semana 2 | 10 a 16 de novembro ",
    subjects: ["Ciências da Natureza", "Matemática"],
    startDate: "2025-11-10T00:00:00-03:00",
    endDate: "2025-11-16T23:59:59-03:00",
    days: [
      {
        "date": "2025-11-10T00:00:00-03:00",
        "title": "SEGUNDA - 10/11",
        "ebookLink": "ebook-10-11",
        "simulatedLink": "simulado-sos-2025-10-11",
        "liveUrl": "5pIYK7d-iFY",
        "asset": "thumb-seg-2",
        "classes": [
          {
            "class": "Biologia (Prof. Jubilut)",
            "hour": "2025-11-10T19:30:00-03:00",
            "url": ""
          },
          {
            "class": "Biologia (Prof. Jubilut)",
            "hour": "2025-11-10T20:00:00-03:00",
            "url": ""
          },
          {
            "class": "INTERVALO",
            "hour": "2025-11-10T20:30:00-03:00",
            "url": ""
          },
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2025-11-10T20:40:00-03:00",
            "url": ""
          },
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2025-11-10T21:10:00-03:00",
            "url": ""
          }
        ]
      },
      {
        "date": "2025-11-11T00:00:00-03:00",
        "title": "TERÇA - 11/11",
        "ebookLink": "ebook-11-11",
        "simulatedLink": "simulado-sos-2025-11-11",
        "liveUrl": "iSFYcUmtCvQ",
        "asset": "thumb-ter-2",
        "classes": [
          {
            "class": "Química (Prof. Thiago)",
            "hour": "2025-11-11T19:30:00-03:00",
            "url": ""
          },
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2025-11-11T20:00:00-03:00",
            "url": ""
          },
          {
            "class": "INTERVALO",
            "hour": "2025-11-11T20:30:00-03:00",
            "url": ""
          },
          {
            "class": "Química (Prof. Thiago)",
            "hour": "2025-11-11T20:40:00-03:00",
            "url": ""
          },
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2025-11-11T21:10:00-03:00",
            "url": ""
          }
        ]
      },
      {
        "date": "2025-11-12T00:00:00-03:00",
        "title": "QUARTA - 12/11",
        "ebookLink": "ebook-12-11",
        "simulatedLink": "simulado-sos-2025-12-11",
        "liveUrl": "J2T7gls_B1g",
        "asset": "thumb-qua-2",
        "classes": [
          {
            "class": "Química (Profa. Ana Paula)",
            "hour": "2025-11-12T19:30:00-03:00",
            "url": ""
          },
          {
            "class": "Física (Prof. Nilo)",
            "hour": "2025-11-12T20:00:00-03:00",
            "url": ""
          },
          {
            "class": "INTERVALO",
            "hour": "2025-11-12T20:30:00-03:00",
            "url": ""
          },
          {
            "class": "Física (Prof. Nilo)",
            "hour": "2025-11-12T20:40:00-03:00",
            "url": ""
          },
          {
            "class": "Química (Profa. Ana Paula)",
            "hour": "2025-11-12T21:10:00-03:00",
            "url": ""
          }
        ]
      },
      {
        "date": "2025-11-13T00:00:00-03:00",
        "title": "QUINTA - 13/11",
        "ebookLink": "ebook-13-11",
        "simulatedLink": "simulado-sos-2025-13-11",
        "liveUrl": "tDqZde9RvFg",
        "asset": "thumb-qui-2",
        "classes": [
          {
            "class": "Biologia (Prof. Jubilut)",
            "hour": "2025-11-13T19:30:00-03:00",
            "url": ""
          },
          {
            "class": "Biologia (Prof. Jubilut)",
            "hour": "2025-11-13T20:00:00-03:00",
            "url": ""
          },
          {
            "class": "INTERVALO",
            "hour": "2025-11-13T20:30:00-03:00",
            "url": ""
          },
          {
            "class": "Física (Prof. Grego)",
            "hour": "2025-11-13T20:40:00-03:00",
            "url": ""
          },
          {
            "class": "Física (Prof. Grego)",
            "hour": "2025-11-13T21:10:00-03:00",
            "url": ""
          }
        ]
      },
      {
        "date": "2025-11-14T00:00:00-03:00",
        "title": "SEXTA - 14/11",
        "ebookLink": "ebook-14-11",
        "simulatedLink": "simulado-sos-2025-14-11",
        "liveUrl": "KTQjmBZ3zmU",
        "asset": "thumb-sex-2",
        "classes": [
          {
            "class": "Matemática (Prof. Vavá)",
            "hour": "2025-11-14T19:30:00-03:00",
            "url": ""
          },
          {
            "class": "Biologia (Prof. Gustavo)",
            "hour": "2025-11-14T20:00:00-03:00",
            "url": ""
          },
          {
            "class": "INTERVALO",
            "hour": "2025-11-14T20:30:00-03:00",
            "url": ""
          },
          {
            "class": "Biologia (Prof. Gustavo)",
            "hour": "2025-11-14T20:40:00-03:00",
            "url": ""
          },
          {
            "class": "Matemática (Prof. Vavá)",
            "hour": "2025-11-14T21:10:00-03:00",
            "url": ""
          }
        ]
      },
      {
        date: "2025-11-15T00:00:00-03:00",
        title: "SÁBADO - 15/11",
        liveUrl: "VYXvX3cHdsA",
        simulatedLink: "simulado-sos-2025-15-11-sabado",
        ebookLink: "ebook-15-11",
        asset: "thumb-sab-2",
        classes: [
          {
            class: "14h00 às 20h00 - Aulão",
            hour: "2025-11-15T14:00:00-03:00",
            end: "2025-11-15T20:00:00-03:00",
            url: "",
          }
        ],
      },
      {
        date: "2025-11-16T00:00:00-03:00",
        title: "DOMINGO - 16/11",
        liveUrl: "R_kBdGBPi0Y",
        asset: "thumb-dom-2",
        classes: [
          {
            class: "Cobertura e correção da prova do Enem",
            hour: "2025-11-16T19:00:00-03:00",
            url: "",
          },
        ],
      },
    ],
  },
];
